import { combineReducers } from "redux";

//Section Reducer Factory
import {
  createSectionFiltersReducer,
  createSectionSelectedFilterIdReducer
} from "src/ui_processors/global/reducer_creators";

// Constants
import { sections } from "src/constants";

export const monitoringSectionReducers = combineReducers({
  filters: createSectionFiltersReducer(sections.monitoring),
  selectedFilterId: createSectionSelectedFilterIdReducer(sections.monitoring)
});
